/**
 * @generated SignedSource<<de4ebbeef4f6cfbe2f2b9f3475c0748b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VimeoVideoStatus = "available" | "generic_error" | "not_found" | "not_found_error" | "quota_exceeded" | "transcode_starting" | "transcoding" | "transcoding_error" | "uploading" | "uploading_error" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useShowVimeoVideo_item$data = {
  readonly reviews: {
    readonly videoReview: {
      readonly status: string | null;
    } | null;
  } | null;
  readonly videoVimeo: {
    readonly status: VimeoVideoStatus | null;
    readonly vimeoId: string | null;
  } | null;
  readonly " $fragmentType": "useShowVimeoVideo_item";
};
export type useShowVimeoVideo_item$key = {
  readonly " $data"?: useShowVimeoVideo_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShowVimeoVideo_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShowVimeoVideo_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "VideoVimeo",
      "kind": "LinkedField",
      "name": "videoVimeo",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vimeoId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemReviewDocumentList",
      "kind": "LinkedField",
      "name": "reviews",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemReview",
          "kind": "LinkedField",
          "name": "videoReview",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "dbd5387fdeeaa95350fa9b4108b99af6";

export default node;
